export default __webpack_public_path__ + "static/media/MazdaBG.d5a5a89a.png";